import React from "react";
import { MultiSelect as MantineMultiSelect, MultiSelectProps, useMantineTheme } from "@mantine/core";

interface CustomMultiSelectProps extends Omit<MultiSelectProps, "styles"> {}

/**
 * MultiSelect - Themed multi-select dropdown component
 * Usage: <MultiSelect label="Choose options" data={options} />
 */
export const MultiSelect: React.FC<CustomMultiSelectProps> = ({ ...props }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <MantineMultiSelect
      {...props}
      styles={{
        label: {
          color: other.textPrimary,
          marginBottom: "0.5rem",
          fontWeight: 500,
        },
        input: {
          backgroundColor: "rgba(26, 20, 16, 0.85)",
          border: "1px solid rgba(245, 238, 224, 0.15)",
          color: other.textPrimary,
          "&:focus": {
            borderColor: other.focusRingColor,
            boxShadow: other.focusRing,
          },
        },
        dropdown: {
          backgroundColor: "rgba(26, 20, 16, 0.98)",
          border: "1px solid rgba(212, 85, 43, 0.2)",
        },
        option: {
          color: other.textPrimary,
          "&:hover": {
            backgroundColor: "rgba(212, 85, 43, 0.12)",
          },
          "&[data-selected]": {
            backgroundColor: other.signatureTerracotta,
            color: other.textPrimary,
          },
        },
        pill: {
          backgroundColor: "rgba(212, 85, 43, 0.2)",
          color: other.textPrimary,
          border: "1px solid rgba(212, 85, 43, 0.35)",
        },
        error: {
          color: other.errorText,
        },
      }}
    />
  );
};

export default MultiSelect;
